import { Subscription } from 'rxjs/internal/Subscription';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { User } from 'src/app/_models/user.model';
import { NoInternetService } from 'src/app/_services/no-internet.service';
import { AuthenticationService, UserService } from '../../_services';
import { ThisPlatform } from '../../_services/platform.service';
import { HeaderModel } from './header.model';
import { HeaderService } from 'src/app/_services/header.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  headerInit: HeaderModel = new HeaderModel();
  subs: Subscription[] = new Array<Subscription>();

  activeSegment: string;
  userMenuDisplayed: boolean = false;
  subheaderHidden: boolean = false;
  userStorage: User;
  defaultBreakpoint: number = 992;
  segmentsHistory: string[] = [];
  deleted: boolean = false;
  noParamUrl: string;

  constructor(
    private userService: UserService,
    public p: ThisPlatform,
    private authService: AuthenticationService,
    private router: Router,
    private navController: NavController,
    public internetServ: NoInternetService,
    public headerServ: HeaderService
  ) {
    this.subs.push(
      authService.currentUser.subscribe(async (user) => {
        this.userStorage = user;
      })
    );
  }

  async ngOnInit() {
    await this.userService.getPermision();
    this.subs.push(
      this.headerServ.getHeaderInit().subscribe((e: HeaderModel) => {
        this.headerInit = e;
        this.checkPermissions();
        this.activeSegment = this.headerInit.activeSegment;
        this.headerInit.segments = this.headerInit.segments
          ? this.headerInit.segments
          : [];
        this.headerInit.mobileSegments = this.headerInit.mobileSegments
          ? this.headerInit.mobileSegments
          : [];

        if (this.headerInit.segments) {
          let filteredSegments = [];
          this.headerInit.segments.forEach((segment) => {
            if (this.userService.hasRoles(segment.permissionKeys)) {
              filteredSegments.push(segment);
            }
          });
          this.headerInit.segments = filteredSegments;
        }

        if (this.headerInit.mobileSegments) {
          let filteredSegments = [];
          this.headerInit.mobileSegments.forEach((segment) => {
            if (this.userService.hasRoles(segment.permissionKeys)) {
              filteredSegments.push(segment);
            }
          });
          this.headerInit.mobileSegments = filteredSegments;
        }
        this.initActiveSegment();
      })
    );
  }

  checkPermissions() {
    setTimeout(() => {
      if (this.headerInit.rightButtons?.length) {
        this.headerInit.rightButtons.forEach(
          async (p) =>
            (p.permission = await this.userService.hasRolesAsync(
              p.rolePermission
            ))
        );
      }
    }, 0);

    this.headerInit.backDefaultHref = this.headerInit.backDefaultHref
      ? this.headerInit.backDefaultHref
      : '/app/home';

    this.noParamUrl = this.router.url.split('?')[0];
  }

  setActiveSegment(event) {
    this.activeSegment = event.detail.value;
    if (!this.deleted) {
      this.segmentsHistory.includes(this.activeSegment)
        ? this.segmentsHistory.unshift(
            this.segmentsHistory.splice(
              this.segmentsHistory.indexOf(this.activeSegment),
              1
            )[0]
          )
        : this.segmentsHistory.unshift(this.activeSegment);
    }
    this.deleted = false;
  }

  hideSubheader(event) {
    event.stopPropagation();
    event.preventDefault();
    this.subheaderHidden = true;
    setTimeout(() => {
      !this.activeSegment?.length
        ? this.navController.navigateBack(this.headerInit.backDefaultHref)
        : this.onBack();
    }, 0);
  }

  scrollTo(event) {
    if (this.p.renderMobile) {
      setTimeout(() => {
        event.target.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'center',
        });
      });
    }
  }

  toggleUserMenu() {
    this.userMenuDisplayed = !this.userMenuDisplayed;
  }

  initActiveSegment() {
    if (
      this.headerInit.segments == undefined ||
      this.headerInit.segments?.length == 0
    ) {
      this.activeSegment = null;
    } else {
      if (!this.activeSegment) {
        this.activeSegment = this.headerInit.segments[0].value;
      }
    }
    this.segmentsHistory.push(this.activeSegment);
  }

  onBack() {
    this.subheaderHidden = false;
    this.router.navigateByUrl(
      this.segmentsHistory?.length > 1
        ? this.noParamUrl + '?section=' + this.segmentsHistory[1]
        : this.headerInit.backDefaultHref
    );
    this.segmentsHistory.splice(1, 1);
    this.deleted = true;
  }

  showMobileSegments(): boolean {
    //Pokazuje mobilne segmenty na desktopie
    if (this.headerInit.showMobileSegmentsOnDesktop) return true;

    //Pokazuje mobilne segmenty na tablecie
    if (this.headerInit.showOnTablet) return this.p.renderSmallDesktop;

    //Pokazuje mobilne segmenty tylko na wersji mobilnej
    return this.p.renderMobile;
  }

  ngOnDestroy() {
    this.subheaderHidden = false;
    for (const e of this.subs) {
      e.unsubscribe();
    }
  }
}
